import * as i0 from '@angular/core';
import { Pipe } from '@angular/core';

var FieldMask;
(function (FieldMask) {
    FieldMask["NONE"] = "NONE";
    FieldMask["CPF"] = "CPF";
    FieldMask["CNPJ"] = "CNPJ";
    FieldMask["CPFCNPJ"] = "CPFCNPJ";
    FieldMask["RG"] = "RG";
    FieldMask["CEP"] = "CEP";
    FieldMask["PHONE"] = "PHONE";
})(FieldMask || (FieldMask = {}));
const FieldMaskMap = new Map([
    [FieldMask.NONE, {
            enumName: FieldMask.NONE,
            description: 'Nenhum',
            optionValue: "",
            value: ''
        }],
    [FieldMask.CPF, {
            enumName: FieldMask.CPF,
            description: 'CPF',
            optionValue: FieldMask.CPF,
            value: '000.000.000-00'
        }],
    [FieldMask.CNPJ, {
            enumName: FieldMask.CNPJ,
            description: 'CNPJ',
            optionValue: FieldMask.CNPJ,
            value: '00.000.000/0000-00'
        }],
    [FieldMask.CPFCNPJ, {
            enumName: FieldMask.CPFCNPJ,
            description: 'CPF/CNPJ',
            optionValue: FieldMask.CPFCNPJ,
            value: '000.000.000-00||00.000.000/0000-00'
        }],
    [FieldMask.RG, {
            enumName: FieldMask.RG,
            description: 'RG',
            optionValue: FieldMask.RG,
            value: '00.000.000-0'
        }],
    [FieldMask.CEP, {
            enumName: FieldMask.CEP,
            description: 'CEP',
            optionValue: FieldMask.CEP,
            value: '00000-000'
        }],
    [FieldMask.PHONE, {
            enumName: FieldMask.PHONE,
            description: 'Telefone/Celular',
            optionValue: FieldMask.PHONE,
            value: '(00) 00000-0000'
        }]
]);
const fieldMaskValues = Array.from(FieldMaskMap.values());
class FieldMaskPipe {
    constructor() { }
    transform(enumName, property) {
        if (!enumName)
            return '';
        return FieldMaskMap.get(enumName)?.[property] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FieldMaskPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: FieldMaskPipe, isStandalone: true, name: "enumFieldMask" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FieldMaskPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'enumFieldMask',
                    standalone: true
                }]
        }], ctorParameters: () => [] });

const fieldsControlNameSeparator = '|';
function labelToControlName(label, dataType, mask) {
    return `${label}${dataType || mask ? fieldsControlNameSeparator : ''}${dataType || ''}${mask ? '#' + mask : ''}`;
}
class ControlNameToLabelPipe {
    constructor() { }
    transform(controlName) {
        return controlName?.split(fieldsControlNameSeparator)[0] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToLabelPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToLabelPipe, isStandalone: true, name: "controlNameToLabel" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToLabelPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'controlNameToLabel',
                    standalone: true
                }]
        }], ctorParameters: () => [] });
class ControlNameToDataTypePipe {
    constructor() { }
    transform(controlName) {
        return controlName?.split(fieldsControlNameSeparator)[1]?.split('#')[0] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToDataTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToDataTypePipe, isStandalone: true, name: "controlNameToDataType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToDataTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'controlNameToDataType',
                    standalone: true
                }]
        }], ctorParameters: () => [] });
class ControlNameToMaskPipe {
    constructor() { }
    transform(controlName) {
        const mask = controlName?.split(fieldsControlNameSeparator)[1]?.split('#')[1] || null;
        if (mask) {
            return FieldMaskMap.get(mask)?.value || null;
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToMaskPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToMaskPipe, isStandalone: true, name: "controlNameToMask" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ControlNameToMaskPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'controlNameToMask',
                    standalone: true
                }]
        }], ctorParameters: () => [] });

var FieldOperator;
(function (FieldOperator) {
    FieldOperator["LESS_THAN"] = "LESS_THAN";
    FieldOperator["LESS_THAN_OR_EQUAL_TO"] = "LESS_THAN_OR_EQUAL_TO";
    FieldOperator["GREATER_THAN"] = "GREATER_THAN";
    FieldOperator["GREATER_THAN_OR_EQUAL_TO"] = "GREATER_THAN_OR_EQUAL_TO";
    FieldOperator["IS_AFTER"] = "IS_AFTER";
    FieldOperator["IS_AFTER_OR_EQUAL_TO"] = "IS_AFTER_OR_EQUAL_TO";
    FieldOperator["IS_BEFORE"] = "IS_BEFORE";
    FieldOperator["IS_BEFORE_OR_EQUAL_TO"] = "IS_BEFORE_OR_EQUAL_TO";
    FieldOperator["IS_TRUE"] = "IS_TRUE";
    FieldOperator["IS_FALSE"] = "IS_FALSE";
    FieldOperator["CONTAINS"] = "CONTAINS";
    FieldOperator["NOT_CONTAINS"] = "NOT_CONTAINS";
    FieldOperator["START_WITH"] = "START_WITH";
    FieldOperator["NOT_START_WITH"] = "NOT_START_WITH";
    FieldOperator["END_WITH"] = "END_WITH";
    FieldOperator["NOT_END_WITH"] = "NOT_END_WITH";
    FieldOperator["IS_TIME_AFTER"] = "IS_TIME_AFTER";
    FieldOperator["IS_TIME_AFTER_OR_EQUAL_TO"] = "IS_TIME_AFTER_OR_EQUAL_TO";
    FieldOperator["IS_TIME_BEFORE"] = "IS_TIME_BEFORE";
    FieldOperator["IS_TIME_BEFORE_OR_EQUAL_TO"] = "IS_TIME_BEFORE_OR_EQUAL_TO";
    FieldOperator["EQUAL_TO"] = "EQUAL_TO";
    FieldOperator["NOT_EQUAL_TO"] = "NOT_EQUAL_TO";
    FieldOperator["IS_NULL"] = "IS_NULL";
    FieldOperator["IS_NOT_NULL"] = "IS_NOT_NULL";
})(FieldOperator || (FieldOperator = {}));
const FieldOperatorMap = new Map([
    [FieldOperator.LESS_THAN, {
            enumName: FieldOperator.LESS_THAN,
            name: 'é menor que',
            requireValue: true,
            expression: "$fieldValue < $value"
        }],
    [FieldOperator.LESS_THAN_OR_EQUAL_TO, {
            enumName: FieldOperator.LESS_THAN_OR_EQUAL_TO,
            name: 'é menor ou igual a',
            requireValue: true,
            expression: "$fieldValue <= $value"
        }],
    [FieldOperator.GREATER_THAN, {
            enumName: FieldOperator.GREATER_THAN,
            name: 'é maior que',
            requireValue: true,
            expression: "$fieldValue > $value"
        }],
    [FieldOperator.GREATER_THAN_OR_EQUAL_TO, {
            enumName: FieldOperator.GREATER_THAN_OR_EQUAL_TO,
            name: 'é maior ou igual a',
            requireValue: true,
            expression: "$fieldValue >= $value"
        }],
    [FieldOperator.IS_AFTER, {
            enumName: FieldOperator.IS_AFTER,
            name: 'é após',
            requireValue: true,
            expression: "Date.parse('$fieldValue') > Date.parse('$value')"
        }],
    [FieldOperator.IS_AFTER_OR_EQUAL_TO, {
            enumName: FieldOperator.IS_AFTER_OR_EQUAL_TO,
            name: 'é após ou igual a',
            requireValue: true,
            expression: "Date.parse('$fieldValue') >= Date.parse('$value')"
        }],
    [FieldOperator.IS_BEFORE, {
            enumName: FieldOperator.IS_BEFORE,
            name: 'é anterior',
            requireValue: true,
            expression: "Date.parse('$fieldValue') < Date.parse('$value')"
        }],
    [FieldOperator.IS_BEFORE_OR_EQUAL_TO, {
            enumName: FieldOperator.IS_BEFORE_OR_EQUAL_TO,
            name: 'é anterior ou igual a',
            requireValue: true,
            expression: "Date.parse('$fieldValue') <= Date.parse('$value')"
        }],
    [FieldOperator.IS_TRUE, {
            enumName: FieldOperator.IS_TRUE,
            name: 'está marcado',
            requireValue: false,
            expression: "$fieldValue == true"
        }],
    [FieldOperator.IS_FALSE, {
            enumName: FieldOperator.IS_FALSE,
            name: 'não está marcado',
            requireValue: false,
            expression: "$fieldValue == false || $fieldValue == null"
        }],
    [FieldOperator.CONTAINS, {
            enumName: FieldOperator.CONTAINS,
            name: 'contém',
            requireValue: true,
            expression: "'$fieldValue'.includes('$value')"
        }],
    [FieldOperator.NOT_CONTAINS, {
            enumName: FieldOperator.NOT_CONTAINS,
            name: 'não contém',
            requireValue: true,
            expression: "!'$fieldValue'.includes('$value')"
        }],
    [FieldOperator.START_WITH, {
            enumName: FieldOperator.START_WITH,
            name: 'começa com',
            requireValue: true,
            expression: "'$fieldValue'.startsWith('$value')"
        }],
    [FieldOperator.NOT_START_WITH, {
            enumName: FieldOperator.NOT_START_WITH,
            name: 'não começa com',
            requireValue: true,
            expression: "!'$fieldValue'.startsWith('$value')"
        }],
    [FieldOperator.END_WITH, {
            enumName: FieldOperator.END_WITH,
            name: 'termina com',
            requireValue: true,
            expression: "'$fieldValue'.endsWith('$value')"
        }],
    [FieldOperator.NOT_END_WITH, {
            enumName: FieldOperator.NOT_END_WITH,
            name: 'não termina com',
            requireValue: true,
            expression: "!'$fieldValue'.endsWith('$value')"
        }],
    [FieldOperator.IS_TIME_AFTER, {
            enumName: FieldOperator.IS_TIME_AFTER,
            name: 'é após',
            requireValue: true,
            expression: "'$fieldValue' > '$value'"
        }],
    [FieldOperator.IS_TIME_AFTER_OR_EQUAL_TO, {
            enumName: FieldOperator.IS_TIME_AFTER_OR_EQUAL_TO,
            name: 'é após ou igual a',
            requireValue: true,
            expression: "'$fieldValue' >= '$value'"
        }],
    [FieldOperator.IS_TIME_BEFORE, {
            enumName: FieldOperator.IS_TIME_BEFORE,
            name: 'é anterior',
            requireValue: true,
            expression: "'$fieldValue' < '$value'"
        }],
    [FieldOperator.IS_TIME_BEFORE_OR_EQUAL_TO, {
            enumName: FieldOperator.IS_TIME_BEFORE_OR_EQUAL_TO,
            name: 'é anterior ou igual a',
            requireValue: true,
            expression: "'$fieldValue <= '$value'"
        }],
    [FieldOperator.EQUAL_TO, {
            enumName: FieldOperator.EQUAL_TO,
            name: 'é igual a',
            requireValue: true,
            expression: "'$fieldValue' == '$value'"
        }],
    [FieldOperator.NOT_EQUAL_TO, {
            enumName: FieldOperator.NOT_EQUAL_TO,
            name: 'não é igual a',
            requireValue: true,
            expression: "'$fieldValue' != '$value'"
        }],
    [FieldOperator.IS_NULL, {
            enumName: FieldOperator.IS_NULL,
            name: 'não está preenchido',
            requireValue: false,
            expression: "('$fieldValue' == 'null' || '$fieldValue' == '')"
        }],
    [FieldOperator.IS_NOT_NULL, {
            enumName: FieldOperator.IS_NOT_NULL,
            name: 'está preenchido',
            requireValue: false,
            expression: "('$fieldValue' != 'null' && '$fieldValue' != '')"
        }]
]);
const FieldOperatorValues = Array.from(FieldOperatorMap.values());
class EnumFieldOperatorPipe {
    constructor() { }
    transform(enumName, property) {
        if (!enumName)
            return null;
        return FieldOperatorMap.get(enumName)?.[property] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldOperatorPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldOperatorPipe, isStandalone: true, name: "enumFieldOperator" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldOperatorPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'enumFieldOperator',
                    standalone: true
                }]
        }], ctorParameters: () => [] });

var FieldDataType;
(function (FieldDataType) {
    FieldDataType["NUMBER"] = "NUMBER";
    FieldDataType["TEXT"] = "TEXT";
    FieldDataType["DATE"] = "DATE";
    FieldDataType["DATETIME"] = "DATETIME";
    FieldDataType["TIME"] = "TIME";
    FieldDataType["BOOLEAN"] = "BOOLEAN";
    FieldDataType["OBJECT"] = "OBJECT";
    FieldDataType["MAP"] = "MAP";
    FieldDataType["FILE"] = "FILE";
})(FieldDataType || (FieldDataType = {}));
const FieldDataTypeMap = new Map([
    [FieldDataType.NUMBER, {
            operators: [FieldOperator.LESS_THAN, FieldOperator.LESS_THAN_OR_EQUAL_TO, FieldOperator.GREATER_THAN, FieldOperator.GREATER_THAN_OR_EQUAL_TO, FieldOperator.EQUAL_TO, FieldOperator.NOT_EQUAL_TO, FieldOperator.IS_NULL, FieldOperator.IS_NOT_NULL],
            inputType: 'number',
            sampleValue: 1,
        }],
    [FieldDataType.TEXT, {
            operators: [FieldOperator.CONTAINS, FieldOperator.NOT_CONTAINS, FieldOperator.START_WITH, FieldOperator.NOT_START_WITH, FieldOperator.END_WITH, FieldOperator.NOT_END_WITH, FieldOperator.EQUAL_TO, FieldOperator.NOT_EQUAL_TO, FieldOperator.IS_NULL, FieldOperator.IS_NOT_NULL],
            inputType: 'text',
            sampleValue: 'Teste'
        }],
    [FieldDataType.DATE, {
            operators: [FieldOperator.IS_AFTER, FieldOperator.IS_AFTER_OR_EQUAL_TO, FieldOperator.IS_BEFORE, FieldOperator.IS_BEFORE_OR_EQUAL_TO, FieldOperator.EQUAL_TO, FieldOperator.NOT_EQUAL_TO, FieldOperator.IS_NULL, FieldOperator.IS_NOT_NULL],
            inputType: 'date',
            sampleValue: '2024-01-01'
        }],
    [FieldDataType.DATETIME, {
            operators: [FieldOperator.IS_TIME_AFTER, FieldOperator.IS_TIME_AFTER_OR_EQUAL_TO, FieldOperator.IS_TIME_BEFORE, FieldOperator.IS_TIME_BEFORE_OR_EQUAL_TO, FieldOperator.EQUAL_TO, FieldOperator.NOT_EQUAL_TO, FieldOperator.IS_NULL, FieldOperator.IS_NOT_NULL],
            inputType: 'datetime-local',
            sampleValue: '2024-01-01T18:00'
        }],
    [FieldDataType.TIME, {
            operators: [FieldOperator.IS_TIME_AFTER, FieldOperator.IS_TIME_AFTER_OR_EQUAL_TO, FieldOperator.IS_TIME_BEFORE, FieldOperator.IS_TIME_BEFORE_OR_EQUAL_TO, FieldOperator.EQUAL_TO, FieldOperator.NOT_EQUAL_TO, FieldOperator.IS_NULL, FieldOperator.IS_NOT_NULL],
            inputType: 'time',
            sampleValue: '12:00'
        }],
    [FieldDataType.BOOLEAN, {
            operators: [FieldOperator.IS_TRUE, FieldOperator.IS_FALSE],
            sampleValue: true
        }],
    [FieldDataType.OBJECT, {
            operators: [],
        }],
    [FieldDataType.MAP, {
            operators: [],
        }],
    [FieldDataType.FILE, {
            operators: [],
            inputType: 'file',
            sampleValue: [
                { key: "1", name: "teste.pdf", size: 41885, type: "application/pdf" },
                { key: "2", name: "teste2.pdf", size: 1500, type: "application/pdf" }
            ]
        }]
]);
const fieldDataTypeValues = Array.from(FieldDataTypeMap.values());
class EnumFieldDataTypePipe {
    constructor() { }
    transform(enumName, property) {
        return FieldDataTypeMap.get(enumName)?.[property] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldDataTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldDataTypePipe, isStandalone: true, name: "enumFieldDataType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldDataTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'enumFieldDataType',
                    standalone: true
                }]
        }], ctorParameters: () => [] });

var FieldEffect;
(function (FieldEffect) {
    FieldEffect["HIDE_FIELD"] = "HIDE_FIELD";
    FieldEffect["DISABLE_FIELD"] = "DISABLE_FIELD";
    FieldEffect["DISABLE_REQUIRED"] = "DISABLE_REQUIRED";
    FieldEffect["ENABLE_REQUIRED"] = "ENABLE_REQUIRED";
})(FieldEffect || (FieldEffect = {}));
const FieldEffectMap = new Map([
    [FieldEffect.HIDE_FIELD, {
            enumName: FieldEffect.HIDE_FIELD,
            description: 'Esconde o campo'
        }],
    [FieldEffect.DISABLE_FIELD, {
            enumName: FieldEffect.DISABLE_FIELD,
            description: 'Desabilita o campo'
        }],
    [FieldEffect.DISABLE_REQUIRED, {
            enumName: FieldEffect.DISABLE_REQUIRED,
            description: 'Remove a obrigatoriedade do campo'
        }],
    [FieldEffect.ENABLE_REQUIRED, {
            enumName: FieldEffect.ENABLE_REQUIRED,
            description: 'Habilita a obrigatoriedade do campo'
        }]
]);
const fieldEffectValues = Array.from(FieldEffectMap.values());
class EnumFieldEffectPipe {
    constructor() { }
    transform(enumName, property) {
        return FieldEffectMap.get(enumName)?.[property] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldEffectPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldEffectPipe, isStandalone: true, name: "enumFieldEffect" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldEffectPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'enumFieldEffect',
                    standalone: true
                }]
        }], ctorParameters: () => [] });

var FieldType;
(function (FieldType) {
    FieldType["TEXT"] = "TEXT";
    FieldType["LARGE_TEXT"] = "LARGE_TEXT";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["DATE"] = "DATE";
    FieldType["CHECKBOX"] = "CHECKBOX";
    FieldType["SELECT"] = "SELECT";
    FieldType["OPTIONS"] = "OPTIONS";
    FieldType["TIME"] = "TIME";
    FieldType["DATE_TIME"] = "DATE_TIME";
    FieldType["FULL_NAME"] = "FULL_NAME";
    FieldType["EMAIL"] = "EMAIL";
    FieldType["FULL_ADDRESS"] = "FULL_ADDRESS";
    FieldType["MAP"] = "MAP";
    FieldType["FIELD_SET"] = "FIELD_SET";
    FieldType["DIVIDER"] = "DIVIDER";
    FieldType["INFO"] = "INFO";
    FieldType["FILE"] = "FILE";
})(FieldType || (FieldType = {}));
const FieldTypeMap = new Map([
    [FieldType.TEXT, {
            enumName: FieldType.TEXT,
            name: 'Texto',
            icon: 'fa-font',
            field: true,
            category: 'Campos Padrões',
            defaultValue: null,
            dataType: FieldDataType.TEXT,
            options: ['hasRequired', 'hasMask', 'hasPlaceholder'],
        }],
    [FieldType.LARGE_TEXT, {
            enumName: FieldType.LARGE_TEXT,
            name: 'Parágrafo',
            icon: 'fa-paragraph',
            field: true,
            category: 'Campos Padrões',
            defaultValue: null,
            dataType: FieldDataType.TEXT,
            options: ['hasRequired', 'hasPlaceholder'],
        }],
    [FieldType.NUMBER, {
            enumName: FieldType.NUMBER,
            name: 'Número',
            icon: 'fa-sort-numeric-up',
            field: true,
            category: 'Campos Padrões',
            defaultValue: null,
            dataType: FieldDataType.NUMBER,
            options: ['hasRequired', 'hasPlaceholder'],
        }],
    [FieldType.DATE, {
            enumName: FieldType.DATE,
            name: 'Data',
            icon: 'fa-calendar',
            field: true,
            category: 'Campos Padrões',
            defaultValue: null,
            dataType: FieldDataType.DATE,
            options: ['hasRequired', 'hasPlaceholder'],
        }],
    [FieldType.CHECKBOX, {
            enumName: FieldType.CHECKBOX,
            name: 'Assinalar',
            icon: 'fa-check-square',
            field: true,
            category: 'Campos Padrões',
            defaultValue: false,
            dataType: FieldDataType.BOOLEAN,
            options: ['hasRequired'],
        }],
    [FieldType.SELECT, {
            enumName: FieldType.SELECT,
            name: 'Seleção',
            icon: 'far fa-check-circle',
            field: true,
            category: 'Campos Padrões',
            defaultValue: null,
            dataType: FieldDataType.TEXT,
            options: ['hasRequired', 'hasOptions', 'hasOptionsColor'],
        }],
    [FieldType.OPTIONS, {
            enumName: FieldType.OPTIONS,
            name: 'Opções',
            icon: 'fa-list',
            field: true,
            category: 'Campos Padrões',
            defaultValue: null,
            dataType: FieldDataType.TEXT,
            options: ['hasRequired', 'hasOptions', 'hasPlaceholder'],
        }],
    [FieldType.TIME, {
            enumName: FieldType.TIME,
            name: 'Hora',
            icon: 'far fa-clock',
            field: true,
            category: 'Campos Padrões',
            defaultValue: null,
            dataType: FieldDataType.TIME,
            options: ['hasRequired'],
        }],
    [FieldType.DATE_TIME, {
            enumName: FieldType.DATE_TIME,
            name: 'Data e Hora',
            icon: 'far fa-calendar-check',
            field: true,
            category: 'Campos Padrões',
            defaultValue: null,
            dataType: FieldDataType.DATETIME,
            options: ['hasRequired'],
        }],
    [FieldType.FILE, {
            enumName: FieldType.FILE,
            name: 'Arquivo',
            icon: 'fa fa-file',
            field: true,
            category: 'Campos Padrões',
            defaultValue: [],
            dataType: FieldDataType.FILE,
            options: ['hasRequired'],
        }],
    [FieldType.FULL_NAME, {
            enumName: FieldType.FULL_NAME,
            name: 'Nome',
            icon: 'far fa-id-badge',
            field: true,
            category: 'Campos Customizados',
            defaultValue: null,
            dataType: FieldDataType.TEXT,
            options: ['hasRequired', 'hasPlaceholder'],
        }],
    [FieldType.EMAIL, {
            enumName: FieldType.EMAIL,
            name: 'E-mail',
            icon: 'fa-envelope',
            field: true,
            category: 'Campos Customizados',
            defaultValue: null,
            dataType: FieldDataType.TEXT,
            options: ['hasRequired', 'hasPlaceholder'],
        }],
    [FieldType.FULL_ADDRESS, {
            enumName: FieldType.FULL_ADDRESS,
            name: 'Endereço',
            icon: 'fa-map-marker-alt',
            field: true,
            category: 'Campos Customizados',
            defaultValue: null,
            dataType: FieldDataType.OBJECT,
            options: ['hasRequired'],
        }],
    [FieldType.MAP, {
            enumName: FieldType.MAP,
            name: 'Mapa',
            icon: 'fa fa-map-marked-alt',
            field: true,
            category: 'Campos Customizados',
            defaultValue: null,
            dataType: FieldDataType.MAP,
            options: ['hasRequired'],
        }],
    [FieldType.FIELD_SET, {
            enumName: FieldType.FIELD_SET,
            name: 'Bloco de Campos',
            icon: 'fas fa-window-maximize',
            field: true,
            category: 'Utilitários',
            defaultValue: null,
            dataType: FieldDataType.OBJECT,
            options: [],
        }],
    [FieldType.DIVIDER, {
            enumName: FieldType.DIVIDER,
            name: 'Divisor',
            icon: 'fas fa-window-minimize',
            field: false,
            category: 'Utilitários',
            defaultValue: null,
            dataType: FieldDataType.OBJECT,
            options: [],
        }],
    [FieldType.INFO, {
            enumName: FieldType.INFO,
            name: 'Informação',
            icon: 'fas fa-info-circle',
            field: false,
            category: 'Utilitários',
            defaultValue: null,
            dataType: FieldDataType.OBJECT,
            options: ['hasDescription'],
        }]
]);
const fieldTypeValues = Array.from(FieldTypeMap.values());
class EnumFieldTypePipe {
    constructor() { }
    transform(enumName, property) {
        return FieldTypeMap.get(enumName)?.[property] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldTypePipe, isStandalone: true, name: "enumFieldType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFieldTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'enumFieldType',
                    standalone: true
                }]
        }], ctorParameters: () => [] });

var FileType;
(function (FileType) {
    FileType["PDF"] = "PDF";
    FileType["IMAGE"] = "IMAGE";
    FileType["DOCUMENT"] = "DOCUMENT";
    FileType["TEXT"] = "TEXT";
})(FileType || (FileType = {}));
const FileTypesMap = new Map([
    [FileType.PDF, {
            enumName: FileType.PDF,
            name: 'PDF',
            accept: '.pdf',
        }],
    [FileType.IMAGE, {
            enumName: FileType.IMAGE,
            name: 'Imagem',
            accept: 'image/*',
        }],
    [FileType.DOCUMENT, {
            enumName: FileType.DOCUMENT,
            name: 'Documentos',
            accept: '.doc, .docx, .odt',
        }],
    [FileType.TEXT, {
            enumName: FileType.TEXT,
            name: 'Texto',
            accept: '.txt',
        }]
]);
const fileTypesValues = Array.from(FileTypesMap.values());
class EnumFileTypesToAccept {
    constructor() { }
    transform(enumNames) {
        return enumNames?.map(enumName => FileTypesMap.get(enumName)?.accept).filter(x => x).join(', ') || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFileTypesToAccept, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EnumFileTypesToAccept, isStandalone: true, name: "enumFileTypesToAccept" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumFileTypesToAccept, decorators: [{
            type: Pipe,
            args: [{
                    name: 'enumFileTypesToAccept',
                    standalone: true
                }]
        }], ctorParameters: () => [] });

var DiagramType;
(function (DiagramType) {
    DiagramType["START"] = "START";
    DiagramType["END"] = "END";
    DiagramType["TASK"] = "TASK";
    DiagramType["SERVICE"] = "SERVICE";
})(DiagramType || (DiagramType = {}));
const DiagramTypeMap = new Map([
    [DiagramType.START, {
            enumName: 'START',
            name: 'Ponto de Início',
            allowMove: true,
            allowEditName: false,
            allowConnect: false,
            useConnectors: false,
            defaultName: 'Início',
            icon: 'far fa-circle',
            actions: ['add', 'connect']
        }],
    [DiagramType.END, {
            enumName: 'END',
            name: 'Ponto de Finalização',
            allowMove: true,
            allowEditName: false,
            allowConnect: true,
            useConnectors: false,
            defaultName: 'Fim',
            icon: 'fas fa-circle',
            actions: ['remove']
        }],
    [DiagramType.TASK, {
            enumName: 'TASK',
            name: 'Tarefa de Usuário',
            allowMove: true,
            allowEditName: true,
            allowConnect: true,
            useConnectors: true,
            defaultName: 'Sem nome',
            icon: 'fas fa-chalkboard-teacher',
            actions: ['add', 'remove', 'connect']
        }],
    [DiagramType.SERVICE, {
            enumName: 'SERVICE',
            name: 'Serviço',
            allowMove: true,
            allowEditName: false,
            allowConnect: true,
            useConnectors: true,
            defaultName: 'Serviço',
            icon: 'fas fa-cogs',
            actions: ['add', 'remove', 'connect']
        }]
]);
const diagramTypeValues = Array.from(DiagramTypeMap.values());
class EnumDiagramTypePipe {
    constructor() { }
    transform(enumName, property) {
        return DiagramTypeMap.get(enumName)?.[property] || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumDiagramTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: EnumDiagramTypePipe, isStandalone: true, name: "enumDiagramType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: EnumDiagramTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'enumDiagramType',
                    standalone: true
                }]
        }], ctorParameters: () => [] });

/**
 * Generated bundle index. Do not edit.
 */

export { ControlNameToDataTypePipe, ControlNameToLabelPipe, ControlNameToMaskPipe, DiagramType, DiagramTypeMap, EnumDiagramTypePipe, EnumFieldDataTypePipe, EnumFieldEffectPipe, EnumFieldOperatorPipe, EnumFieldTypePipe, EnumFileTypesToAccept, FieldDataType, FieldDataTypeMap, FieldEffect, FieldEffectMap, FieldMask, FieldMaskMap, FieldMaskPipe, FieldOperator, FieldOperatorMap, FieldOperatorValues, FieldType, FieldTypeMap, FileType, FileTypesMap, diagramTypeValues, fieldDataTypeValues, fieldEffectValues, fieldMaskValues, fieldTypeValues, fieldsControlNameSeparator, fileTypesValues, labelToControlName };
